<sui-progress class="tiny progress-bar" [value]="value"></sui-progress>
